var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 15C24.2833 15 24.5551 15.0973 24.7554 15.2704L32.6871 22.1238C33.1043 22.4843 33.1043 23.0688 32.6871 23.4293C32.2699 23.7897 31.5935 23.7897 31.1763 23.4293L25.0683 18.1516L25.0683 32.0769C25.0683 32.5867 24.59 33 24 33C23.41 33 22.9317 32.5867 22.9317 32.0769V18.1516L16.8237 23.4293C16.4065 23.7897 15.7301 23.7897 15.3129 23.4293C14.8957 23.0688 14.8957 22.4843 15.3129 22.1238L23.2446 15.2704C23.4449 15.0973 23.7167 15 24 15Z",
    fill: "#353A41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.55cf0c30409011f1839cb3dec98c0b8a.svg";
export { ForwardRef as ReactComponent };